import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const STORAGE_KEY = "fg_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        const t = setTimeout(() => setVisible(true), 1200);
        return () => clearTimeout(t);
      }
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "accepted");
    } catch (e) {}
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[60]"
          data-testid="cookie-banner"
        >
          <div className="rounded-2xl border border-white/10 bg-black/80 backdrop-blur-xl p-6 shadow-2xl">
            <p className="text-sm text-muted-foreground leading-relaxed">
              Questo sito usa cookie tecnici necessari al funzionamento e, per la
              prenotazione, servizi di terze parti (Calendly). Continuando
              accetti.{" "}
              <a
                href="/privacy"
                className="text-primary underline underline-offset-2 hover:text-primary/80"
                data-testid="cookie-privacy-link"
              >
                Informativa
              </a>
              .
            </p>
            <div className="mt-4 flex items-center gap-3">
              <button
                onClick={accept}
                className="rounded-full bg-primary text-primary-foreground px-6 py-2.5 text-xs tracking-[0.15em] hover:bg-primary/90 transition-colors duration-300"
                data-testid="cookie-accept"
              >
                ACCETTA
              </button>
              <a
                href="/privacy"
                className="text-xs tracking-[0.12em] text-muted-foreground hover:text-foreground transition-colors duration-300"
                data-testid="cookie-more"
              >
                SCOPRI DI PIÙ
              </a>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
